// extracted by mini-css-extract-plugin
module.exports = {"main-component":"executePopupHeaderImage_main-component__3cTQP"};